import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Work from './components/Work';
import Skills from './components/Skills';
import Contact from './components/Contact';
import FloatingSocials from './components/FloatingSocials';
import ScrollToTop from './components/ScrollToTop';

function App() {
 
  return (
    <>
      <Navbar/>
      <FloatingSocials/>
      <ScrollToTop/>
      <Home/>
      <About/>
      <Work/>
      <Skills/>
      <Contact/>
    </>
  );
}

export default App;
